import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Groupes de packs sélectionnés dans l'espace Configuration.
 * Multi-sélection : on peut afficher le contenu de tous les groupes, d'un seul,
 * ou de plusieurs à la fois. Partagé entre les pages Blocks / Items / Entities.
 */
interface ConfigGroupState {
  selectedGroupIds: string[];
  setSelectedGroupIds: (ids: string[]) => void;
}

export const useConfigGroupStore = create<ConfigGroupState>()(
  persist(
    (set) => ({
      selectedGroupIds: [],
      setSelectedGroupIds: (selectedGroupIds) => set({ selectedGroupIds }),
    }),
    {
      name: 'recubebe-config-groups',
      partialize: (state) => ({ selectedGroupIds: state.selectedGroupIds }),
    }
  )
);
